import React from 'react'

import icon1 from '../../../../images/terms/icon1.svg'
import icon2 from '../../../../images/terms/icon2.svg'
import icon3 from '../../../../images/terms/icon3.svg'

import styles from './styles.module.scss'
import money from "../../../../images/internShips/money.svg";
import car from "../../../../images/internShips/car.svg";
import home from "../../../../images/internShips/home.svg";

const Terms = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <p className={styles.title}>Все для вашего комфорта</p>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>
            Условия стажировки в п.Вольгинский
          </p>
        </div>
        <div className={styles.information}>
          <div>
            <img src={money} alt='icons' />
            <div className={styles.information_block}>
            <p className={styles.information_block_title}>Ежемесячная стипендия</p>
            <p className={styles.information_block_desc}>Выплачиваем 40 000 ₽ (до вычета налогов) каждый месяц</p>
            </div>
          </div>
          <div>
            <img src={car} alt='icons' />
            <div className={styles.information_block}>
            <p className={styles.information_block_title}>Трансфер из Москвы и обратно</p>
            <p className={styles.information_block_desc}>В первый и заключительный день стажировки</p>
            </div>
          </div>
          <div>
            <img src={home} alt='icons' />
            <div className={styles.information_block}>
            <p className={styles.information_block_title}>Проживание и обеды за счёт компании</p>
            <p className={styles.information_block_desc}>В пансионате на территории R&D-парка</p>
            </div>
          </div>
        </div>

        <div className={styles.right_wrapper}>
          <p className={styles.title}>
            Условия стажировки в Алабушево
          </p>
        </div>
        <div className={styles.information}>
          <div>
            <img src={money} alt='icons' />
            <div className={styles.information_block}>
            <p className={styles.information_block_title}>Ежемесячная стипендия</p>
            <p className={styles.information_block_desc}>Выплачиваем 40 000 ₽ (до вычета налогов) каждый месяц</p>
            </div>
          </div>
          <div>
            <img src={car} alt='icons' />
            <div className={styles.information_block}>
            <p className={styles.information_block_title}>Трансфер</p>
            <p className={styles.information_block_desc}>От ж/д станции Крюково и обратно в рабочие дни</p>
            </div>
          </div>
          <div>
            <img src={home} alt='icons' />
            <div className={styles.information_block}>
            <p className={styles.information_block_title}>Питание за счет компании</p>
            <p className={styles.information_block_desc}>В столовой на территории завода</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Terms
